import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

// ----------------------------------------------------------------------
//   Slice del panel /reports/daily (bloque C onboarding v2).
//   Estado ligero — la mayoría del trabajo lo hace el backend.
// ----------------------------------------------------------------------

const initialState = {
  loading: false,
  error: null,
  reports: [],           // DtoDailyReport[]

  settings: null,        // DtoDailyReportSettings
  settingsLoading: false,
  saving: false,
  sending: false,
};

const slice = createSlice({
  name: "dailyReports",
  initialState,
  reducers: {
    startLoading(state) { state.loading = true; state.error = null; },
    setReports(state, action) { state.reports = action.payload; state.loading = false; },
    setError(state, action) { state.error = action.payload; state.loading = false; },

    setSettingsLoading(state, action) { state.settingsLoading = action.payload; },
    setSettings(state, action) { state.settings = action.payload; state.settingsLoading = false; },

    setSaving(state, action) { state.saving = action.payload; },
    setSending(state, action) { state.sending = action.payload; },
    prependReport(state, action) {
      const existing = state.reports.findIndex((r) => r.id === action.payload.id);
      if (existing >= 0) state.reports[existing] = action.payload;
      else state.reports.unshift(action.payload);
    },
  },
});

export default slice.reducer;

export function fetchDailyReports() {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoading());
      const res = await axios.get("reports/daily");
      dispatch(slice.actions.setReports(res.data));
    } catch (err) {
      dispatch(slice.actions.setError(err?.response?.data?.message || err.message));
    }
  };
}

export function fetchDailyReportSettings() {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setSettingsLoading(true));
      const res = await axios.get("reports/daily/settings");
      dispatch(slice.actions.setSettings(res.data));
    } catch (err) {
      dispatch(slice.actions.setError(err?.response?.data?.message || err.message));
      dispatch(slice.actions.setSettingsLoading(false));
    }
  };
}

export function saveDailyReportSettings(settings) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setSaving(true));
      await axios.put("reports/daily/settings", settings);
      dispatch(slice.actions.setSettings(settings));
    } finally {
      dispatch(slice.actions.setSaving(false));
    }
  };
}

/** Fuerza generación + envío del día especificado (null = ayer). */
export function sendDailyReportNow(date = null) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setSending(true));
      const res = await axios.post("reports/daily/send-now", { date });
      dispatch(slice.actions.prependReport(res.data));
      return res.data;
    } finally {
      dispatch(slice.actions.setSending(false));
    }
  };
}

/** Devuelve URL SAS del PDF para descargar. */
export function getDailyReportDownloadUrl(id) {
  return async () => {
    const res = await axios.get(`reports/daily/${id}/download`);
    return res.data?.url;
  };
}
